import { FC, useState } from 'react';
import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import ConfirmCloseDialog from './ConfirmCloseDialog';

interface DiscardChangesButtonProps {
  onDiscard: () => void;
  disabled?: boolean;
  loading?: boolean;
  label?: string;
  confirmTitle?: string;
  confirmMessage?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export const DiscardChangesButton: FC<DiscardChangesButtonProps> = ({
  onDiscard,
  disabled = false,
  loading = false,
  label,
  confirmTitle,
  confirmMessage,
  confirmLabel,
  cancelLabel,
}) => {
  const { t } = useTranslation(['common']);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const handleDiscardClick = () => {
    setShowConfirmDialog(true);
  };

  const handleConfirmDiscard = () => {
    setShowConfirmDialog(false);
    onDiscard();
  };

  const handleCancelDiscard = () => {
    setShowConfirmDialog(false);
  };

  return (
    <>
      <Button
        variant="outline"
        color="yellow"
        onClick={handleDiscardClick}
        disabled={disabled || loading}
        loading={loading}
      >
        {label || t('discard.label', { defaultValue: 'Discard Changes' })}
      </Button>

      <ConfirmCloseDialog
        opened={showConfirmDialog}
        onCancel={handleCancelDiscard}
        onConfirm={handleConfirmDiscard}
        title={
          confirmTitle ||
          t('discard.confirmTitle', {
            defaultValue: 'Discard Changes',
          })
        }
        message={
          confirmMessage ||
          t('discard.confirmMessage', {
            defaultValue:
              'Are you sure you want to discard all changes? This action cannot be undone.',
          })
        }
        confirmLabel={
          confirmLabel ||
          t('discard.confirmLabel', {
            defaultValue: 'Discard Changes',
          })
        }
        cancelLabel={
          cancelLabel || t('discard.cancelLabel', { defaultValue: 'Cancel' })
        }
        confirmColor="yellow"
      />
    </>
  );
};

export default DiscardChangesButton;
